import { useState } from 'react';
const AccordionGroup = props => {
  const {
    0: groupActiveIndex,
    1: setGroupActiveIndex
  } = useState(null);
  return props.render(groupActiveIndex, setGroupActiveIndex);
};
export default AccordionGroup;